import { createIcon } from '@chakra-ui/react';

export const IconLicense = createIcon({
  displayName: 'IconLicense',
  viewBox: '0 0 40 40',
  defaultProps: {
    height: '40px',
    width: '40px',
  },
  path: (
    <g fill="none">
      <circle cx="11" cy="16" r="10" stroke="currentColor" strokeWidth="2" />
      <path
        d="M4 34.4502V23.4502C5 24.1169 7.8 25.5502 11 25.9502C14.2 26.3502 17 24.4502 18 23.4502V34.4502L11 32.3221L4 34.4502Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
      />
    </g>
  ),
});
